
// task
export const SET_TASK_LIST = 'SET_TASK_LIST'

// rebuild
export const SET_REBUILD_SEARCHING = 'SET_REBUILD_SEARCHING'
export const SET_REBUILD_TASK_LIST_PAGE = 'SET_REBUILD_TASK_LIST_PAGE'
export const SET_REBUILD_TASK_LIST_PAGE_TOTAL = 'SET_REBUILD_TASK_LIST_PAGE_TOTAL'
export const SET_REBUILDEND_TASK_LIST_QUERY = 'SET_REBUILDEND_TASK_LIST_QUERY'
export const SET_REBUILD_TASK_STATE_TYPE = 'SET_REBUILD_TASK_STATE_TYPE'
export const SET_REBUILD_LIST_PAGE_SIZE = 'SET_REBUILD_LIST_PAGE_SIZE'
export const SET_REBUILD_SORT = 'SET_REBUILD_SORT'
export const SET_REBUILD_END_STATUS = 'SET_REBUILD_END_STATUS'
export const CHANGE_REBUILD_QUERY = 'CHANGE_REBUILD_QUERY'
export const SET_REBUILD_DATA = 'SET_REBUILD_DATA'

// render
export const SET_RENDER_LIST = 'SET_RENDER_LIST'
export const SET_RENDER_LIST_PAGE = 'SET_RENDER_LIST_PAGE'
export const SET_RENDER_LIST_PAGE_TOTAL = 'SET_RENDER_LIST_PAGE_TOTAL'
export const SET_RENDER_LIST_QUERY = 'SET_RENDER_LIST_PAGE_QUERY'
export const SET_RENDER_SORT = 'SET_RENDER_SORT'
export const SET_RENDER_LIST_EXPEND = 'SET_RENDER_LIST_EXPEND'
export const SET_RENDER_LIST_PACK_UP = 'SET_RENDER_LIST_PACK_UP'
export const SET_RENDER_LIST_PAGE_SIZE = 'SET_RENDER_LIST_PAGE_SIZE'
export const SET_RENDER_TASK_STATE_TYPE = 'SET_RENDER_TASK_STATE_TYPE'
export const SET_RENDER_TASK_COUNT = 'SET_RENDER_TASK_COUNT'
export const SET_RENDERING_LIST_QUERY = 'SET_RENDERING_LIST_QUERY'
export const SET_RENDEREND_LIST_QUERY = 'SET_RENDEREND_LIST_QUERY'
export const SET_RENDERING_STATUS_LIST = 'SET_RENDERING_STATUS_LIST'
export const SET_RENDEREND_STATUS_LIST = 'SET_RENDEREND_STATUS_LIST'
export const SET_RENDER_RUNNING_SEARCHING = 'SET_RENDER_RUNNING_SEARCHING'
export const SET_RENDER_END_SEARCHING = 'SET_RENDER_END_SEARCHING'
export const SET_RENDER_END_EXPORTING = 'SET_RENDER_END_EXPORTING'
export const SET_CONFIG_FILE = 'SET_CONFIG_FILE'
export const SET_MULTI_FRAME_CONFIG_FILE = 'SET_MULTI_FRAME_CONFIG_FILE'
export const IS_MULTI_FRAME = 'IS_MULTI_FRAME'
export const RESET_RENDERING_LIST_QUERY = 'RESET_RENDERING_LIST_QUERY'
export const RESET_RENDEREND_LIST_QUERY = 'RESET_RENDEREND_LIST_QUERY'
export const SET_FRAME_STATISTIC_MESSAGE = 'SET_FRAME_STATISTIC_MESSAGE'
export const SET_TASK_SCENE_TYPE = 'SET_TASK_SCENE_TYPE'

// search
export const SET_SEARCH_LIST_PAGE = 'SET_SEARCH_LIST_PAGE'
export const SET_SEARCH_LIST_PAGE_TOTAL = 'SET_SEARCH_LIST_PAGE_TOTAL'
export const SET_SEARCH_LIST = 'SET_SEARCH_LIST'
export const SET_SEARCH_SORT = 'SET_SEARCH_SORT'
export const SET_SEARCH_LIST_EXPEND = 'SET_SEARCH_LIST_EXPEND'
export const SET_SEARCH_LIST_PACK_UP = 'SET_SEARCH_LIST_PACK_UP'
export const SET_SEARCH_LIST_PAGE_SIZE = 'SET_SEARCH_LIST_PAGE_SIZE'
export const SET_SEARCH_TASK_ID = 'SET_SEARCH_TASK_ID'
export const SET_RENDER_TASK_LIST = 'SET_RENDER_TASK_LIST'
// sky3
export const SET_SKY_THREE_TASK_LIST = 'SET_SKY_THREE_TASK_LIST'
export const SET_SKY_THREE_TASK_LIST_PAGE = 'SET_SKY_THREE_TASK_LIST_PAGE'
export const SET_SKY_THREE_TASK_LIST_PAGE_TOTAL = 'SET_SKY_THREE_TASK_LIST_PAGE_TOTAL'
export const SET_SKY_THREE_TASK_LIST_QUERY = 'SET_SKY_THREE_TASK_LIST_PAGE_QUERY'
export const SET_SKY_THREE_TASK_STATE_TYPE = 'SET_SKY_THREE_TASK_STATE_TYPE'
export const SET_SKY_THREE_LIST_PAGE_SIZE = 'SET_SKY_THREE_LIST_PAGE_SIZE'
export const SET_SKY_THREE_SORT = 'SET_SKY_THREE_SORT'
export const SET_SKY_THREE_RUNNING_STATUS = 'SET_SKY_THREE_RUNNING_STATUS'
export const SET_SKY_THREE_END_STATUS = 'SET_SKY_THREE_END_STATUS'
export const SET_SKY_THREE_SEARCHING = 'SET_SKY_THREE_SEARCHING'
export const CHANGE_SKY_THREE_QUERY = 'CHANGE_SKY_THREE_QUERY'
export const RESET_SKY_THREE_TASK_LIST_QUERY = 'RESET_SKY_THREE_TASK_LIST_QUERY'

// handle
export const SET_TASK_GROUP = 'SET_TASK_GROUP'
export const SET_DETAIL_IMG_MESSAGE = 'SET_DETAIL_IMG_MESSAGE'
export const SET_JIGSAW_PREVIEW = 'SET_JIGSAW_PREVIEW'

// preHandle
export const SET_PRE_HANDLE_LIST = 'SET_PRE_HANDLE_LIST'
export const SET_PRE_HANDLE_LIST_PAGE = 'SET_PRE_HANDLE_LIST_PAGE'
export const SET_PRE_HANDLE_SORT = 'SET_PRE_HANDLE_SORT'
export const SET_PRE_HANDLE_LIST_QUERY = 'SET_PRE_HANDLE_LIST_QUERY'
export const SET_PRE_HANDLE_LIST_PAGE_TOTAL = 'SET_PRE_HANDLE_LIST_PAGE_TOTAL'
export const SET_PRE_HANDLE_LIST_PAGE_SIZE = 'SET_PRE_HANDLE_LIST_PAGE_SIZE'
export const SET_PRE_HANDLE_SEARCHING = 'SET_PRE_HANDLE_SEARCHING'
export const RESET_PRE_HANDLE_LIST_QUERY = 'RESET_PRE_HANDLE_LIST_QUERY'

// dayannode
export const SET_DAYANTASK_LIST = 'SET_DAYANTASK_LIST'

// publish
export const SET_PUBLISH_LIST = 'SET_PUBLISH_LIST'
export const SET_PUBLISH_LIST_PAGE = 'SET_PUBLISH_LIST_PAGE'
export const SET_PUBLISH_LIST_PAGE_SIZE = 'SET_PUBLISH_LIST_PAGE_SIZE'
export const SET_PUBLISH_LIST_PAGE_SIZE_TOTAL = 'SET_PUBLISH_LIST_PAGE_SIZE_TOTAL'
export const SET_PUBLISH_LIST_QUERY = 'SET_PUBLISH_LIST_QUERY'
export const SET_PUBLISH_LIST_SEARCHING = 'SET_PUBLISH_LIST_SEARCHING'
export const SET_PUBLISH_SORT = 'SET_PUBLISH_SORT'
